























































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';
import TableMixin from '@root/common/mixins/table';
import TableWidthMixin from '@root/common/mixins/table-width';
import ParkingLotSearch from '@/components/parking-lot-search/index.vue';
import PlateInput from '@/components/plate-input/index.vue';
import LockModal from './components/lock-modal.vue';
// 接口
import Utils from '@root/utils/common';
import moment from 'moment';
import {
  DictLockStatus,
  dictLockStatusMap,
  dictLockSourceMap,
  dictSendStatusMap
} from '@/types/lock-car-management/dictionaries';
import { queryLockList, IQueryLockListParam, unlock, IUnlockParam } from '@/api/lock-car-management';

@Component({
  name: 'LockRecord',
  components: {
    ParkingLotSearch,
    PlateInput,
    LockModal
  }
})
export default class LockRecord extends Mixins(TableMixin, TableWidthMixin) {
  private lockModalVisible = false; // 锁车弹窗可见性
  private moment = moment;
  private lockStatusOptions: IOption[] = Utils.toLabelVal(dictLockStatusMap);
  lockSourceOptions: any[] = [
    { label: '全部', value: '' },
    ...Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.lock_car_socure)
  ];
  private DictLockStatus = DictLockStatus;
  private tableLoading = false;
  private tableData = [];
  get tableColums() {
    return [
      {
        title: '序号',
        width: 70,
        customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`
      },
      {
        title: '车场名称',
        dataIndex: 'parkName',
        scopedSlots: { customRender: 'parkName' },
        width: 170
      },
      {
        title: '车牌号',
        dataIndex: 'plate',
        customRender: (text: any) => text || '--',
        width: 120
      },
      {
        title: '停车订单号',
        dataIndex: 'orderId',
        scopedSlots: { customRender: 'orderId' },
        width: 250
      },
      {
        title: '手机号',
        dataIndex: 'phoneNumber',
        customRender: (text: any) => text || '--',
        width: 140
      },
      {
        title: '锁车时间',
        dataIndex: 'lockTime',
        customRender: (text: any) => text || '--',
        width: 220
      },
      {
        title: '解锁时间',
        dataIndex: 'unlockTime',
        customRender: (text: any) => text || '--',
        width: 220
      },
      {
        title: '锁车状态',
        dataIndex: 'stateDesc',
        customRender: (text: any) => text || '--',
        width: 140
      },
      {
        title: '操作人',
        dataIndex: 'operator',
        customRender: (text: any) => text || '--',
        width: 140
      },
      {
        title: '操作来源',
        dataIndex: 'source',
        customRender: (text: any) => text || '--',
        width: 140
      },
      {
        title: '下发状态',
        dataIndex: 'sendStatus',
        customRender: (text: any) => text || '--',
        width: 140
      },
      {
        title: '操作',
        dataIndex: 'operation',
        scopedSlots: { customRender: 'operation' },
        fixed: 'right',
        width: 100
      }
    ];
  }
  private filterParam: any = {
    parkIds: [],
    plate: '',
    plateHead: '',
    plateTail: '',
    lockTimeStart: '',
    lockTimeEnd: '',
    lockStatus: '',
    lockSource: ''
  };
  created() {
    this.fetchTableData();
  }
  search() {
    this.current = 1;
    this.fetchTableData();
  }
  clear({ defaultParkIdList }) {
    this.plateInputModel = true;
    this.filterParam = {
      parkIds: defaultParkIdList,
      plate: '',
      plateHead: '',
      plateTail: '',
      lockTimeStart: '',
      lockTimeEnd: '',
      lockStatus: '',
      lockSource: ''
    };
    this.search();
  }
  plateInputModel = false;
  /** 车牌改变 */
  plateChange([plateHead, plateTail]: string[]) {
    this.filterParam.plateHead = plateHead ? plateHead : '';
    this.filterParam.plateTail = plateTail;
  }

  /** 时间更新 */
  // 默认时间查询条件初始化
  get defaultTime() {
    if (this.filterParam.lockTimeStart && this.filterParam.lockTimeEnd) {
      return [
        this.moment(this.filterParam.lockTimeStart, 'YYYY-MM-DD HH:mm:ss'),
        this.moment(this.filterParam.lockTimeEnd, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.lockTimeStart) {
      return [this.moment(this.filterParam.lockTimeEnd, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
  // 监听时间变化，更新查询条件
  private onFilterTimeChange(date: any, dateString: any) {
    const [startTime, endTime] = dateString;
    this.filterParam.lockTimeStart = startTime;
    this.filterParam.lockTimeEnd = endTime;
  }

  private disabledDate(current: any) {
    return current && current >= moment().endOf('day');
  }

  /** 表格查询 */
  public async fetchTableData() {
    try {
      if (this.tableLoading) return;
      this.tableLoading = true;
      const { parkIds, plateHead, plateTail, lockTimeStart, lockTimeEnd, lockStatus, lockSource } = this.filterParam;
      // if (plateTail && plateHead === '') {
      //   return this.$message.error('请先选择省份再进行查询')
      // }
      const { status, msg, code, data } = await queryLockList({
        parkId: parkIds.join(','),
        plateHead,
        plateTail,
        lockTimeStart,
        lockTimeEnd,
        status: lockStatus,
        source: lockSource,
        currPage: this.current,
        pageSize: this.pageSize
      });
      if (data) {
        const { datas = [], totalNum = 0 } = data || {};
        this.total = Number(totalNum);
        if (datas.length > 0) {
          this.tableData = Object.freeze(datas);
        } else {
          this.tableData = [];
        }
      }
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    } finally {
      this.tableLoading = false;
    }
  }

  /** 解锁 */
  async unlockHandle(id: string) {
    try {
      const { status, code, msg, data } = await unlock({
        id
      });
      this.$message.success('解锁成功');
      // 更新表格数据
      await this.fetchTableData();
    } catch (error) {
      this.$message.error((error && error.msg) || '系统繁忙，请稍后再试');
    }
  }

  /** 锁车 */
  showLockModal() {
    this.lockModalVisible = true;
  }
  lockCancel() {
    this.lockModalVisible = false;
  }
  lockOk() {
    this.lockModalVisible = false;
    this.fetchTableData();
  }
}
